<div class="page-content">
    <div class="page-header">
        <h1>Rechercher un point de livraison</h1>
        <div class="page-description">Rechercher un point à partir d'une adresse ou un numéro Siret</div>
    </div>

    <div class="page-body">
        <div class="cards-container">
            <div class="row" [formGroup]="searchFormGroup">

                <!-- Numéro SIRET -->
                <div class="col-sm-6 g-2">
                    <label for="numSiret">Numéro Siret</label>
                    <ed-textfield innerId="numSiret" type="text" placeholder="Entrez un numéro Siret" formControlName="numSiret"></ed-textfield>
                    <div *ngIf="searchFormGroup.get('numSiret')?.errors?.['pattern'] && searchFormGroup.get('numSiret')?.touched">
                        <p class="error">Un numéro SIRET doit contenir 14 chiffres.</p>
                    </div>
                </div>

                <!-- Catégorie client -->
                <div class="col-sm-6 g-2">
                    <label for="categorieClientFinalCode">Catégorie client</label>
                    <ed-select innerId="categorieClientFinalCode" [options]="categorieClientFinalCodeOptions" formControlName="categorieClientFinalCode" placeholder="Ex: PRO"></ed-select>
                    <div *ngIf="searchFormGroup.get('categorieClientFinalCode')?.errors?.['invalidValue'] && searchFormGroup.get('categorieClientFinalCode')?.touched">
                        <p class="error">Catégorie invalide. Valeurs possibles : PRO ou RES.</p>
                    </div>
                </div>


                <!-- Numéro et nom de voie -->
                <div class="col-sm-6 g-2">
                    <label for="numeroEtNomVoie">Numéro et nom de voie</label>
                    <ed-textfield innerId="numeroEtNomVoie" type="text" placeholder="Ex: 8 Rue Martel" formControlName="numeroEtNomVoie"></ed-textfield>
                </div>

                <!-- Code postal -->
                <div class="col-sm-3 g-2">
                    <label for="codePostal">Code Postal</label>
                    <ed-textfield innerId="codePostal" type="text" placeholder="Code postal" formControlName="codePostal"></ed-textfield>
                    <div *ngIf="searchFormGroup.get('codePostal')?.errors?.['pattern'] && searchFormGroup.get('codePostal')?.touched">
                        <p class="error">Un code postal doit contenir 5 chiffres.</p>
                    </div>
                </div>

                <!-- Code INSEE -->
                <div class="col-sm-3 g-2">
                    <label for="codeInseeCommune">Code INSEE de la commune</label>
                    <ed-textfield innerId="codeInseeCommune" type="text" placeholder="Code INSEE" formControlName="codeInseeCommune"></ed-textfield>
                    <div *ngIf="searchFormGroup.get('codeInseeCommune')?.errors?.['pattern'] && searchFormGroup.get('codeInseeCommune')?.touched">
                        <p class="error">Un code INSEE doit contenir 5 chiffres.</p>
                    </div>
                </div>

                <!-- Escalier / étage / appart -->
                <div class="col-sm-6 g-2">
                    <label for="escalierEtEtageEtAppartement">Escalier / Étage / Appartement</label>
                    <ed-textfield innerId="escalierEtEtageEtAppartement" type="text" placeholder="Ex: Esc A, 2e étage, App 12" formControlName="escalierEtEtageEtAppartement"></ed-textfield>
                </div>

                <!-- Bâtiment -->
                <div class="col-sm-6 g-2">
                    <label for="batiment">Bâtiment</label>
                    <ed-textfield innerId="batiment" type="text" formControlName="batiment"></ed-textfield>
                </div>

                <!-- Lieu-dit -->
                <div class="col-sm-6 g-2">
                    <label for="lieuDit">Lieu-dit</label>
                    <ed-textfield innerId="lieuDit" type="text" formControlName="lieuDit" placeholder="Ex: Paris"></ed-textfield>
                </div>

                <!-- Matricule ou N° série -->
                <div class="col-sm-6 g-2">
                    <label for="matriculeOuNumeroSerie">Matricule / Numéro de série</label>
                    <ed-textfield innerId="matriculeOuNumeroSerie" type="text" formControlName="matriculeOuNumeroSerie"></ed-textfield>
                </div>

                <!-- Domaine tension alimentation -->
                <div class="col-sm-6 g-2">
                    <label for="domaineTensionAlimentationCode">Domaine de tension</label>
                    <ed-select innerId="domaineTensionAlimentationCode" [options]="domaineTensionOptions" formControlName="domaineTensionAlimentationCode" placeholder="Ex: BTINF"></ed-select>
                    <div *ngIf="searchFormGroup.get('domaineTensionAlimentationCode')?.errors?.['invalidValue'] && searchFormGroup.get('domaineTensionAlimentationCode')?.touched">
                        <p class="error">Valeur invalide. Choix autorisés : BTINF, BTSUP, HTA, HTB.</p>
                    </div>
                </div>

                <!-- Nom client ou raison sociale -->
                <div class="col-sm-6 g-2">
                    <label for="nomClientFinalOuDenominationSociale">Nom du client final / Raison sociale</label>
                    <ed-textfield innerId="nomClientFinalOuDenominationSociale" type="text" formControlName="nomClientFinalOuDenominationSociale" placeholder="Ex: Energies Demain"></ed-textfield>
                </div>


                <!-- Recherche hors périmètre -->
                <div class="col-sm-6 g-2">
                    <label for="rechercheHorsPerimetre">Recherche hors périmètre</label>
                    <input type="checkbox" id="rechercheHorsPerimetre" formControlName="rechercheHorsPerimetre">
                </div>

            </div>

            <!-- Erreur de validation globale -->
            <div class="row">
                <!-- SIRET ou adresse obligatoire -->
                <div *ngIf="searchFormGroup.errors?.['siretOuAdresse'] && searchFormGroup.touched">
                    <p class="error">Veuillez renseigner un numéro SIRET valide ou une adresse complète (code postal + code INSEE + voie).</p>
                </div>

                <!-- Recherche hors périmètre : adresse incomplète -->
                <div *ngIf="searchFormGroup.errors?.['adresseIncompletHorsPerimetre'] && searchFormGroup.get('rechercheHorsPerimetre')?.value">
                    <p class="error">Pour une recherche hors périmètre, l’adresse complète est obligatoire (code postal, code INSEE, voie).</p>
                </div>

                <!-- Recherche hors périmètre : nom manquant -->
                <div *ngIf="searchFormGroup.errors?.['nomClientHorsPerimetre'] && searchFormGroup.get('rechercheHorsPerimetre')?.value">
                    <p class="error">Le nom ou la dénomination sociale doit contenir au moins 3 caractères.</p>
                </div>

                <!-- Compléments d'adresse seuls sans voie ou nom -->
                <div *ngIf="searchFormGroup.errors?.['complementSansAncrage']">
                    <p class="error">Un complément d’adresse (étage, bâtiment, lieu-dit) ne peut être utilisé seul sans voie ou nom de client.</p>
                </div>

                <!-- Code postal et code INSEE incohérents -->
                <div *ngIf="searchFormGroup.errors?.['coupleCpInseeIncomplet']">
                    <p class="error">Le code postal et le code INSEE doivent être saisis ensemble.</p>
                </div>
            </div>

            <div class="row">
                <ed-button (click)="valid()" [disabled]="!searchFormGroup.valid">Rechercher le point d'accès</ed-button>
            </div>

            <br/>
            <div class="row">
                <h1>Résultats:</h1>
            </div>

            <table-card
            *ngIf="resultTableDataSource"
            [isLoading]="isLoading"
            [dataSource]="resultTableDataSource"
            [displayedColumns]="resultTableDisplayedColumns">
        </table-card>

        </div>
    </div>
</div>